var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"reports-container"},[_c('report-list',{attrs:{"id":_vm.provider_id ? _vm.provider_id : -1,"idType":"provider"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }